<template>
    <div class="introduce-unit-features">
      <v-card class="offer">
        <v-toolbar
          color="#E72480"
          dark
        >

          <v-toolbar-title style="font-weight: bold;font-size: 2rem">واحدها و امکانات</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn icon @click="addDialog" >
            <v-icon>mdi-plus-thick  </v-icon>
          </v-btn>
        </v-toolbar>
        <div class="empty-array" v-if="originalIntroduction.length===0">اطلاعاتی برای نشان دادن نداریم.</div>
        <div class="empty-array" v-if="originalIntroduction.length===0">لطفا اطلاعات جدید را وارد کنید.</div>
        <div  class="child-offer">
          <v-card
            v-for="item in originalIntroduction"
          >
            <div style="display: flex;flex-direction: column;padding: 10px">
              <div style="display: grid;grid-template-columns: 1fr 1fr;width: 100%">
                <div style="grid-column: 1" class="text">
                  <v-card-title style="display: flex">
                    <div class="ml-1"  style='font-weight: bold'>
                      عنوان:
                    </div>
                    <div>
                      {{item.title}}
                    </div>
                  </v-card-title>
                  <v-card-text style="max-width: 35vw;display: flex">
                    <div class="ml-1" style="font-weight: bold;font-size: 18px">
                      متن:
                    </div>
                    <div>
                      {{item.text}}
                    </div>
                  </v-card-text>
                  <v-card-actions>
                    <v-card-text style="display: flex">
                      <div class="ml-1" style="font-weight: bold;font-size: 18px">
                      لینک:
                    </div>
                      <div>
                        {{item.buttonLink}}
                      </div>
                    </v-card-text>
                    <v-card-text style="display: flex">
                      <div class="ml-1" style="font-weight: bold;font-size: 18px">
                        متن دکمه :
                      </div>
                      <div>
                        {{item.buttonText}}
                      </div>
                    </v-card-text>
                  </v-card-actions>
                </div>
                <div style="grid-column: 2" class="image">
                  <div style="font-weight: bold;font-size: 18px">عکس اصلی معرفی:</div>
                  <v-img
                    lazy-src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1xSB2iFkkqe-n5iYhIGetiDnHcP-fZg9-Vg&usqp=CAU"
                    :src="item.file ? baseUrl+item.file : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1xSB2iFkkqe-n5iYhIGetiDnHcP-fZg9-Vg&usqp=CAU'"
                    height="250px"
                  >  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                    <div class="icons">
                      <v-btn :loading="loadingDeleteItem" style="background-color: white" @click="deleteData(item.id)" icon>
                        <v-icon color="red">mdi-delete  </v-icon>
                      </v-btn>
                      <v-btn @click="editData(item.file , item.text,item.title,item.buttonLink,item.buttonText,item.images , item.id)" style="background-color: white" icon>
                        <v-icon color="blue" >mdi-pencil  </v-icon>
                      </v-btn>
                    </div>

                  </v-img>
                </div>
              </div>
              <div style="font-weight: bold;font-size: 18px;margin:1rem">عکس های زیر عکس صفحه اصلی:</div>
              <div class="images">
                <v-img
                  v-for="img in item.images"
                  :src="baseUrl+img.path"
                  height="150px"
                  width="200px"
                  lazy-src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1xSB2iFkkqe-n5iYhIGetiDnHcP-fZg9-Vg&usqp=CAU"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                  <v-btn :loading="loadingDeleteImage"  style="background-color: white" @click="deleteImageUnique(item.id,img.id)" icon >
                  <v-icon color="red">mdi-delete </v-icon >
                  </v-btn>
                </v-img>
              </div>
            </div>

          </v-card>
        </div>
      </v-card>
      <v-dialog
        v-model="dialog"
        max-width="900"
        @click:outside="eybiyokh"
      >
        <v-card style="background-color: #d2d2d2;padding: 40px">
          <v-form validation ref="from" v-model="valid">
            <v-row>
              <v-file-input
                v-model="files"
                class="input"
                chips
                accept="image/png, image/jpeg, image/bmp"
                v-on:change="showImage($event)"
                v-on:click:clear="deleteImage"
                prepend-icon="mdi-camera"
                placeholder="عکس اصلی معرفی  را اپلود کنید"
              ></v-file-input>
            </v-row>
            <v-row>
              <v-textarea
              class="text-input"
              counter
              label="متن قسمت معرفی مورد نظر را وارد کنید"
              row-height="5"
              v-model="text"
              rows="3"
              :rules="[rules1]"
              required
              ></v-textarea>
            </v-row>
            <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="title"
                :rules="[titleRules]"
                :counter="50"
                label="تیتر"
                required
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="4"
              class="select-link"
            >
              <v-select
                style="flex-direction: column-reverse"
                :items="items"
                label="لینک نوشته"
                solo
                v-model="buttonLink"
                required
                :rules="[buttonLinkRules]"
              ></v-select>
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model="buttonText"
                :rules="[buttonTextRules]"
                :counter="25"
                label="متن دکمه لینک"
                required
              ></v-text-field>
            </v-col>

            </v-row>
            <v-row style="margin-top: 20px;margin-bottom: 10px">
              <v-file-input
                v-model="imagesPath"
                class="input"
                multiple
                chips
                accept="image/png, image/jpeg, image/bmp"
                v-on:change="showImages($event)"
                v-on:click:clear="deleteImages"
                prepend-icon="mdi-camera"
                placeholder="عکس های صفحه معرفی  را اپلود کنید"
              ></v-file-input>
            </v-row>
          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="black darken-1"
              text
              @click="eybiyokh()"
            >
              بیخیال
            </v-btn>
            <v-btn
              color="black darken-1"
              text
              @click="sendData"
              v-show="!isEdit"
              :disabled="!valid"
              :loading="sendLoading"
            >
              انجام شد
            </v-btn>
            <v-btn
              color="black darken-1"
              text
              @click="recordData"
              v-show="isEdit"
              :disabled="!valid"
              :loading="editLoading"

            >
              ویرایش کنید.
            </v-btn>
          </v-card-actions>
          <div class="images">
            <div style="display: flex;">
              <v-col>
                <p style="margin-bottom: 6px"> عکس اصلی قسمت معرفی :</p>
                <v-img max-width="500" max-height="400" :src="image"></v-img>
              </v-col>
              <v-col>
                <p style="margin-bottom: 6px">عکس های فرعی قسمت معرفی :</p>
                <v-img max-width="250" max-height="150" v-for="myImage in imagesShow" :src="myImage"></v-img>
              </v-col>
            </div>
          </div>

        </v-card>
      </v-dialog>
    </div>
</template>

<script>
  import {toBase64} from "../../../../plugins/toBase64";
  import {deleteIntroduction, putIntroduction, setIntroduction} from "../../../../api/introduceUnitsAndFeatures";
  import {mapActions, mapGetters} from "vuex";

  export default {
        name: "introduceUnitsAndFeatures",
      data:()=>({
        loadingDeleteItem:false,
        loadingDeleteImage:false,
        baseUrl:'',
        buttonLink:'',
        buttonText:'',
        dialog:false,
        isEdit:false,
        sendLoading:false,
        editLoading:false,
        id:0,
        text:'',
        title:'',
        files:[],
        fileCheck:true,
        textCheck:true,
        check:true,
        valid:true,
        params:{file:'',text:'',id:''},
        image:'',
        isData:false,
        imagesPath:[],
        imagesShow:[],
        otherImage:[],
        dataImagesFile:[],
        items: [ '' ,'فروشگاه ها', 'امکانات', 'باشگاه مشتریان', 'اخبار و اطلاعیه ها', 'راهنمای طبقات', 'خرید و اجاره'],

        rules1: v =>{
          if(v !== '' && v.length <=350)
          {
            return true
          }
          else
          {
            return `متن وارد شده باید کمتر از ۳۲۵ کاراکتر باشد`
          }
        },
        titleRules: v =>{
          if(v !== '' && v.length <=50)
          {
            return true
          }
          else
          {
            return `متن وارد شده باید کمتر از ۵۰ کاراکتر باشد`
          }
        },
        buttonLinkRules: v =>{
          if(v !== '')
          {
            return true
          }
          else
          {
            return `لینک مورد نظر خود را انتخاب کنید.`
          }
        },
        buttonTextRules: v =>{
          if(v !== '' && v.length <=25)
          {
            return true
          }
          else
          {
            return `متن وارد شده باید کمتر از ۲۵ کاراکتر باشد`
          }
        },

      }),
      methods:{
        showImage(e){
          if(e) {
            this.image = URL.createObjectURL(e)
          }
        },
        deleteImage()
        {
          this.image = ''
        },
        showImages(e){
          if(e.length!==0) {
            this.dataImagesFile.push(...this.imagesPath)
            e.forEach((i) => {
              this.imagesShow.push(URL.createObjectURL(i))
            })
          }
        },
        deleteImages(){
          this.imagesShow = []
          this.dataImagesFile = []
        },
        addDialog () {
          this.isEdit = false
          this.dialog = true
        },
        async deleteImageUnique(itemId,imageId){
          let yes = confirm('مظمئنی عکس را می خوای پاک کنی ؟')
          if(yes) {
            this.loadingDeleteImage = true
            let image = {id: imageId, path: "0"}
            let imagesDelete = []
            imagesDelete.push(image)
            let params = {
              id: itemId,
              images: imagesDelete
            }
            await putIntroduction(params, itemId).then(() => {
              this.getIntroductionReq()
              this.snackBarAction({
                color: "#4CAF50",
                textSnackBar: 'عملیات فرستادن با موفقیت اعمال شد',
                showSnackbar: true
              })
            }).catch(() => {
              this.snackBarAction({color: "#ff5252", textSnackBar: 'متاسفانه تغییرات اعمال نشد', showSnackbar: true})
            })
          }
          this.loadingDeleteImage=false
        },
        async sendData(){
          this.sendLoading = true
          this.otherImage = []
        let mainImg  = this.files ?  await toBase64(this.files) : null
          if(this.dataImagesFile.length!==0 )
          {
            for(let i=0 ; i<this.dataImagesFile.length ; i++)
            {
              let myObject = {path:''}
              myObject.path = await toBase64(this.dataImagesFile[i])
              this.otherImage.push(myObject)
            }
          }
          else{
            this.otherImage = null
          }
          let params = {
            title:this.title,
            text:this.text,
            buttonLink :this.buttonLink,
            buttonText : this.buttonText,
            file: mainImg,
            images:this.otherImage
          }
           await  setIntroduction(params).then(()=>{
                this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات فرستادن با موفقیت اعمال شد', showSnackbar:true})
          }).catch(()=>{
            this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
          })
          await  this.getIntroductionReq()
          this.dialog = false
          this.sendLoading = false
          this.files=[]
          this.title = ''
          this.buttonLink = ''
          this.buttonText = ''
          this.imagesShow = []
          this.imagesPath= []
          this.dataImagesFile = []
          this.text=''
          this.image = ''
          this.eybiyokh()
        },
        async imagesToBase64() {
          try {
            let i ;
            let v= [] ;
            for (i=0 ; i<this.dataImagesFile.length ;i++){
              let myObject={}
              myObject = {path: this.dataImagesFile[i] ? await toBase64(this.dataImagesFile[i]) : null}
              v.push(myObject)
            }
             return  v
          }
          catch (e) {
            // console.log('خطاااااااا', e);
          }
          // }
        },

        async recordData(){
          this.editLoading = true
          let myObject = {path:''}
          let mainImg =  await toBase64(this.files)
          this.otherImage = []
          if(this.dataImagesFile.length!==0 )
          {
            this.otherImage =await this.imagesToBase64()
          }
          else{
            this.otherImage = null
          }
          if(this.otherImage) {
            this.otherImage = this.otherImage.filter(i => {
              let obj = {'path':'','id':''}
              obj.path = i.path
              obj.id = undefined
              return obj
            })
          }

          let params = {
            id:this.id,
            title:this.title,
            text:this.text,
            buttonLink :this.buttonLink,
            buttonText : this.buttonText,
            file: mainImg,
            images:this.otherImage
          }
           await putIntroduction(params, this.id).then(() => {
                this.getIntroductionReq()
                this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات فرستادن با موفقیت اعمال شد', showSnackbar:true})
            }).catch(()=>{
                this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
            })

          this.dialog = false
          this.editLoading = false
          this.files=[]
          this.title = ''
          this.buttonLink = ''
          this.buttonText = ''
          this.imagesShow = []
          this.imagesPath= []
          this.dataImagesFile = []
          this.text=''
          this.image = ''
          this.$mount()
        },
        eybiyokh(){
          this.dialog = false
          this.files=[]
          this.title = ''
          this.buttonLink = ''
          this.buttonText = ''
          this.imagesShow = []
          this.imagesPath= []
          this.dataImagesFile = []
          this.text=''
          this.image = ''
        },
        async deleteData(id){
          let yes = confirm("مطمئنی میخوای پاک کنی!");
          if (yes) {
            this.loadingDeleteItem = true
            this.files=[]
            try{
             await deleteIntroduction(id).then(() => {
                this.getIntroductionReq()
                this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات فرستادن با موفقیت اعمال شد', showSnackbar:true})
              }).catch(()=>{
                this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})

              })
            }catch (e) {
///
            }
            this.loadingDeleteItem = false
          }

        },
        editData(file , text,title,buttonLink,buttonText,images ,id){
          this.files = []
          this.imagesPath = []
          this.dataImagesFile = []
          this.image = this.baseUrl+file
          this.text = text
          this.title = title
          this.id=id
          this.buttonText = buttonText
          this.buttonLink = buttonLink
          this.imagesShow = []
          if(images !== null)
          {
            this.imagesShow = images
          }
          this.dialog = true
          this.isEdit = true
        },
        ...mapActions({
          getIntroductionReq:'introduceUnitsAndFeatures/fetchIntroduceUnit',
          snackBarAction:'snackBar/snackBarAction'

        }),
      },
      computed: {
        ...mapGetters({
          originalIntroduction: 'introduceUnitsAndFeatures/get_introduceUnit',
        })
      },

     async mounted() {
          this.baseUrl = process.env.VUE_APP_BASE_URL
          this.isData= true
          await this.getIntroductionReq()

     }
    }
</script>
<style>
  .introduce-unit-features .v-icon.v-icon::after{
    background-color: unset;
  }
  .text-input .v-label.v-label  {
    font-size: 1.1rem !important;
    top: 0;
  }
  .text-input .v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot{
    height: 2rem !important;
  }
  .text-input .v-textarea textarea{
    font-size: 1.25rem;
  }
  .date-input{
    margin-bottom: 2rem;
  }
  .select-link .v-input__control{
    flex-direction: column-reverse !important;
  }
  .v-responsive__content{
    width: unset !important;
  }
</style>

<style scoped>
  .offer{
    width: 86.5%;
    margin: 100px auto 100px;
  }
  .child-offer{
    padding: 50px;
    display: grid;
  }
  .card-offer{
    margin: 0;
  }
  .form-slider{
    display: flex;
    flex-direction: column;
    max-width: 1185px;
    margin: 0 auto;
  }
  .title-input
  {
    min-height: unset;
  }
  .input{
    direction: ltr;
  }
  .row{
    justify-content: center;
    align-items: flex-end;
    flex-direction: row-reverse;
  }
  .text{
    font-family: anjoman;
    font-size: 1.25rem;
  }

  .link-input{
    width: 40%;
  }
  .image{
    position:  relative;
  }
  .icons{
    position: absolute;
    top: 0;
    left: 0;
  }
  .empty-array{
    font-size: 2rem;
    margin-right: 3rem;
    font-weight: bold;
  }
  .images{
    margin-top: 2px;
    display: grid;
    grid-template-columns: 1fr 1fr auto;
    grid-row-gap: 5px;
  }
</style>

